<kendo-maskedtextbox style="max-width:100%" [mask]="phoneNumberMask" (valueChange)="onChange($event)">
</kendo-maskedtextbox>